<template>
  <div class="rest-select-component">
    <b-modal ref="rest-cash-group-selector-modal"
             hide-footer
             scrollable
             hide-header-close
             no-close-on-backdrop
             size="lg"
             :title="$t('#TR-choose-restaurants-and-cash-groups')"
             @hidden="onCloseSelector">


      <div class="row d-flex d-md-none mb-3">
        <div class="col-6 text-center">
          <div class="btn btn-outline-success"
               style="min-width: 90px"
               :class="{'active': tab === 'rest'}"
               @click="onChangeTab('rest')">
            <span class="mdi mdi-food-fork-drink"></span>
            <span class="d-none d-sm-inline"> {{ $t("#TR-restaurants") }}</span>
          </div>
        </div>
        <div class="col-6 text-center">
          <div class="btn btn-outline-success"
               style="min-width: 90px"
               :class="{'active': tab === 'cash'}"
               @click="onChangeTab('cash')">
            <span class="mdi mdi-server-network"></span>
            <span class="d-none d-sm-inline"> {{ $t("#TR-cash-groups") }}</span>
            <span class="badge badge-success fz-18 ml-2">{{ filteredCashGroups.length }}</span>
          </div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-12 col-md-6 restaurants-selector"
             :class="{'show': tab === 'rest'}">
          <span class="text-success font-weight-bold mb-2 d-none d-md-block">
            {{ $t("#TR-restaurants") }}
          </span>
          <b-list-group>
            <b-list-group-item v-for="(rest, idx) in restList"
                               :key="idx"
                               :class="{ active: rest.selected }"
                               @click="onSelectRest(idx)">
              {{ rest.name }}
            </b-list-group-item>
          </b-list-group>
        </div>

        <div class="col-12 col-md-6 cash-groups-selector"
             :class="{'show': tab === 'cash'}">
          <span class="text-success font-weight-bold mb-2 d-none d-md-block">
            {{ $t("#TR-cash-groups") }}
          </span>
          <div v-if="filteredCashGroups.length < 1"
               class="text-muted text-center mt-5 mb-2">
            {{ $t("#TR-no-cash-groups-available") }}
          </div>
          <b-list-group>
            <b-list-group-item v-for="(group, idx) in filteredCashGroups"
                               :key="idx"
                               :class="{ active: group.selected}"
                               @click="onSelectCashGroup(group)">
              {{ group.name }}
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-sm-5">
          <button class="btn btn-success btn-block"
                  type="button"
                  @click="onApplySelector">
            {{ $t("#TR-apply") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { ApiSys } from '@/services/api';
  import MSG from '@/services/notify';

  export default {
    name: 'RestCashGroupSelector',

    props: {
      limitRest: {
        type: Number,
        default: function () {
          return 0;
        }
      }
    },

    data() {
      return {
        tab: 'rest',
        selector: false,
        restList: null,
        cashGroupList: null,
        filteredCashGroups: [],
        selected: {
          rests: [],
          cashGroups: []
        }
      };
    },

    async mounted() {
      await this.getRestaurantList();
      await this.getCashGroupList();
    },

    methods: {

      async getRestaurantList() {
        const result = await ApiSys.getRestaurants();

        if (result.error) {
          MSG.error(result.error, this);
          this.restList = [];
        } else {
          this.restList = result.data.map(rest => {
            rest.selected = false;

            return rest;
          });
        }
      },

      async getCashGroupList() {
        const cashGroups = await ApiSys.getCashGroups();
        this.cashGroupList = cashGroups.data;
      },

      async onSelectRest(idx) {
        const rest = this.restList[idx];
        const findRest = this.selected.rests.findIndex(r => r.guid === rest.guid);
        if (findRest === -1) {

          if (this.limitRest === 1) {

            this.restList.map(function (rest) {
              rest.selected = false;

              return rest;
            });

            this.selected.rests = [];
          }

          rest.selected = true;
          this.selected.rests.push(rest);
        } else {
          rest.selected = false;
          this.selected.rests.splice(findRest, 1);
        }

        await this.filteringCacheGroup();
        this.$forceUpdate();
      },

      onSelectCashGroup(cashGroup) {

        if (this.limitRest === 1) {

          if (cashGroup.selected) {
            cashGroup.selected = false;
          } else {
            this.cashGroupList.forEach((group) => {
              group.selected = false;
            });
            cashGroup.selected = true;
          }
        } else {
          cashGroup.selected = !cashGroup.selected;
        }

        this.$forceUpdate();
      },

      filteringCacheGroup: async function () {
        const tempCahe = JSON.parse(JSON.stringify(this.filteredCashGroups));
        this.filteredCashGroups = [];

        this.selected.rests.forEach((rest) => {
          this.cashGroupList.forEach((cashGroup) => {
            cashGroup.selected = false;
            if (rest.guid === cashGroup.restaurantGuid) {
              this.filteredCashGroups.push(cashGroup);
            }
          });
        });

        this.filteredCashGroups.forEach((item) => {
          const find = tempCahe.findIndex(v => v.guid === item.guid);
          if (find !== -1) {
            item.selected = tempCahe[find].selected;
          }
        });
      },

      onApplySelector() {
        this.selected.cashGroups = this.filteredCashGroups.filter(function (e) {
          return e.selected;
        });
        const selected = JSON.parse(JSON.stringify(this.selected));
        this.$emit('onApplySelector', selected);
        this.$refs['rest-cash-group-selector-modal'].hide();
      },

      onOpenSelector() {
        this.$refs['rest-cash-group-selector-modal'].show();
      },

      onCloseSelector() {
        this.$refs['rest-cash-group-selector-modal'].hide();
      },

      onChangeTab(tab) {
        this.tab = tab;
      }

    }
  };
</script>

<style lang="stylus">

@media (max-width: 768px) {
  .cash-groups-selector {
    display: none

    &.show {
      display: block
    }
  }

  .restaurants-selector {
    display: none

    &.show {
      display: block
    }
  }
}

</style>
